function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 10c0-.865.11-1.703.316-2.504A3 3 0 002.99 2.867 9.99 9.99 0 017.325.362a3 3 0 005.348 0 9.99 9.99 0 014.335 2.505 3 3 0 002.675 4.63 10.037 10.037 0 010 5.007 3 3 0 00-2.675 4.629 9.99 9.99 0 01-4.335 2.505 3 3 0 00-5.348 0 9.99 9.99 0 01-4.335-2.505 3 3 0 00-2.675-4.63A10.056 10.056 0 010 10zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0110 16c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0115.196 13a4.993 4.993 0 012.77-2.25 8.134 8.134 0 000-1.5A4.993 4.993 0 0115.195 7a4.993 4.993 0 01-.564-3.524 7.988 7.988 0 00-1.297-.75A4.993 4.993 0 0110 4a4.993 4.993 0 01-3.335-1.274 7.99 7.99 0 00-1.297.75A4.993 4.993 0 014.804 7a4.993 4.993 0 01-2.77 2.25 8.125 8.125 0 000 1.5A4.993 4.993 0 014.805 13h-.001zM10 13a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2z",
  fill: "#19496B"
});

var SvgBespokenGearIcon2 = function SvgBespokenGearIcon2(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenGearIcon2;